import { type InsuranceCorporateIdentity } from "../types";

export function GrozBeckertLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M179 158H218V196H179V158Z" fill="black" />
      <path d="M179 209H218V331H179V209Z" fill="black" />
      <path
        d="M64 199.508C64 124.56 124.632 64 199.667 64C273.363 64 332.99 122.553 335 195.492H301.167C299.157 141.289 254.269 98.1278 199.667 98.1278C143.726 98.1278 98.1681 143.632 98.1681 199.508C98.1681 244.008 126.977 282.15 167.174 295.534V331C107.883 316.278 64 262.744 64 199.508Z"
        fill="#006EB7"
      />
      <path
        d="M231 209H266.333V260.474L301 209H334.667L303.667 254.458L339.667 325.652V209H374.667V260.474L409.333 209H443.333L412 254.458L451 331H408.667L387.333 285.542L374.667 303.258V331H342.333H339.667H300.333L279 285.542L266.333 303.258V331H231V209Z"
        fill="black"
      />
      <path
        d="M187 440.917V357H223.409C236.511 357 247.461 362.219 247.461 376.04C247.461 388.417 235.207 394.606 224.692 396.937V397.164C237.442 399.227 251 405.849 251 420.371C251 428.85 245.473 441 224.568 441L187 440.917ZM207.699 390.542C209.089 390.867 210.514 391.027 211.942 391.017C221.235 391.017 224.775 384.972 224.775 378.928C224.775 371.275 218.876 370.924 214.529 370.924H207.699V390.542ZM207.699 426.642C210.75 426.967 213.821 427.084 216.889 426.993C221.939 426.993 228.314 424.93 228.314 417.71C228.314 407.251 219.248 404.24 207.616 404.24L207.699 426.642Z"
        fill="#D20A11"
      />
      <path
        d="M261 440.917V357H297.444C310.538 357 321.499 362.219 321.499 376.04C321.499 388.417 309.233 394.482 298.708 396.937V397.164C311.45 399.227 325 405.849 325 420.371C325 428.85 319.447 441 298.584 441L261 440.917ZM281.719 390.542C283.111 390.865 284.536 391.025 285.966 391.017C295.289 391.017 298.832 384.972 298.832 378.928C298.832 371.275 292.927 370.924 288.577 370.924H281.719V390.542ZM281.719 426.642C284.774 426.967 287.847 427.084 290.918 426.993C295.994 426.993 302.375 424.93 302.375 417.71C302.375 407.251 293.28 404.24 281.657 404.24L281.719 426.642Z"
        fill="#D20A11"
      />
    </svg>
  );
}

export const GrozBeckert: InsuranceCorporateIdentity = {
  id: "groz-beckert",
  name: "Groz-Beckert",
  logo: GrozBeckertLogo,
  backgroundColor: "white",
  textColor: "#000000",
  wildcard: "groz beckert",
  type: "statutory",
};
